import { render, staticRenderFns } from "./ProjectsHeader.vue?vue&type=template&id=d49f2450&scoped=true&"
import script from "./ProjectsHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsHeader.vue?vue&type=style&index=0&id=d49f2450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49f2450",
  null
  
)

export default component.exports